var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    [
      _c(
        "v-flex",
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                [
                  _c("h3", { staticClass: "headline mb-0 admin-header" }, [
                    _vm._v("Users"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", icon: "", color: "grey lighten-1" },
                      on: { click: _vm.refreshList },
                    },
                    [_c("v-icon", [_vm._v("fas fa-sync")])],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: {
                      "append-icon": "fal fa-search",
                      placeholder: "Search",
                      "single-line": "",
                      "hide-details": "",
                      clearable: "",
                    },
                    model: {
                      value: _vm.search,
                      callback: function ($$v) {
                        _vm.search = $$v
                      },
                      expression: "search",
                    },
                  }),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs3: "" } },
                    [
                      _c("v-select", {
                        attrs: {
                          label: "Select roles",
                          items: _vm.allRoles,
                          multiple: "",
                          clearable: "",
                          "small-chips": "",
                          "deletable-chips": "",
                          "item-text": "name",
                          "item-value": "id",
                        },
                        model: {
                          value: _vm.selectedRoles,
                          callback: function ($$v) {
                            _vm.selectedRoles = $$v
                          },
                          expression: "selectedRoles",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-dialog",
                    {
                      attrs: { "max-width": "1000px" },
                      model: {
                        value: _vm.deletedUsersDialog,
                        callback: function ($$v) {
                          _vm.deletedUsersDialog = $$v
                        },
                        expression: "deletedUsersDialog",
                      },
                    },
                    [
                      _vm.deletedUsersDialog
                        ? _c("deleted-users", {
                            on: {
                              userUnDeleted: _vm.refreshList,
                              usersUnDeleted: _vm.refreshList,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tooltip",
                    {
                      attrs: { bottom: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on }) {
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  {
                                    attrs: { icon: "" },
                                    on: {
                                      click: function ($event) {
                                        _vm.deletedUsersDialog = true
                                      },
                                    },
                                  },
                                  on
                                ),
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        size: "20",
                                        color: "grey lighten-1",
                                      },
                                    },
                                    [_vm._v("far fa-recycle")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [_vm._v(" "), _c("span", [_vm._v("Manage Recycle Bin")])]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-dialog",
                {
                  attrs: { "max-width": "600px", persistent: "" },
                  model: {
                    value: _vm.dialog,
                    callback: function ($$v) {
                      _vm.dialog = $$v
                    },
                    expression: "dialog",
                  },
                },
                [
                  _c(
                    "v-card",
                    [
                      _c("v-card-title", [
                        _c("span", { staticClass: "headline" }, [
                          _vm._v("User"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-form",
                            {
                              ref: "userForm",
                              on: {
                                submit: function ($event) {
                                  $event.preventDefault()
                                },
                              },
                              model: {
                                value: _vm.validUser,
                                callback: function ($$v) {
                                  _vm.validUser = $$v
                                },
                                expression: "validUser",
                              },
                            },
                            [
                              _c(
                                "v-container",
                                { attrs: { "grid-list-md": "" } },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { wrap: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: { xs12: "", sm6: "", md6: "" },
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              rules: [_vm.rules.required],
                                              label: "Name *",
                                            },
                                            model: {
                                              value: _vm.editedItem.name,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "name",
                                                  $$v
                                                )
                                              },
                                              expression: "editedItem.name",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: { xs12: "", sm6: "", md6: "" },
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              rules: [_vm.rules.formatEmail],
                                              label: "Email",
                                            },
                                            model: {
                                              value: _vm.editedItem.email,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "email",
                                                  $$v
                                                )
                                              },
                                              expression: "editedItem.email",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: { xs12: "", sm6: "", md6: "" },
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              rules: [_vm.rules.formatPhone],
                                              label: "Phone",
                                            },
                                            model: {
                                              value: _vm.editedItem.phone,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "phone",
                                                  $$v
                                                )
                                              },
                                              expression: "editedItem.phone",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: { xs12: "", sm6: "", md6: "" },
                                        },
                                        [
                                          _c("v-autocomplete", {
                                            attrs: {
                                              autofocus: false,
                                              autocomplete: "off",
                                              items: _vm.timeZEntries,
                                              label: "Timezone",
                                            },
                                            model: {
                                              value: _vm.editedItem.timeZone,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "timeZone",
                                                  $$v
                                                )
                                              },
                                              expression: "editedItem.timeZone",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs12: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              autocomplete: "new-password",
                                              rules: [
                                                _vm.rules.required,
                                                _vm.rules.formatLogin,
                                              ],
                                              label: "Username *",
                                            },
                                            model: {
                                              value: _vm.editedItem.login,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "login",
                                                  $$v
                                                )
                                              },
                                              expression: "editedItem.login",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      !(_vm.editedItem.id > 0)
                                        ? _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs12: "",
                                                sm12: "",
                                                md12: "",
                                              },
                                            },
                                            [
                                              _c("v-checkbox", {
                                                attrs: {
                                                  label:
                                                    "Email User to Setup Password*",
                                                },
                                                model: {
                                                  value:
                                                    _vm.editedItem.sendPwdEmail,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.editedItem,
                                                      "sendPwdEmail",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "editedItem.sendPwdEmail",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.editedItem.sendPwdEmail &&
                                      !(_vm.editedItem.id > 0)
                                        ? _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs12: "",
                                                sm12: "",
                                                md12: "",
                                              },
                                            },
                                            [
                                              _c("PasswordEntry", {
                                                on: {
                                                  "password-updated":
                                                    _vm.updateCreateUserPassword,
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isSU
                                        ? _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs12: "",
                                                sm6: "",
                                                md6: "",
                                              },
                                            },
                                            [
                                              _c("v-checkbox", {
                                                attrs: {
                                                  label: "Collection Agent?",
                                                },
                                                model: {
                                                  value:
                                                    _vm.editedItem
                                                      .collectionAgent,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.editedItem,
                                                      "collectionAgent",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "editedItem.collectionAgent",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: { xs12: "", sm6: "", md6: "" },
                                        },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              items: _vm.allRoles,
                                              "item-text": "name",
                                              "item-value": "id",
                                              "menu-props": {
                                                maxHeight: "400",
                                              },
                                              label: "Roles",
                                              multiple: "",
                                            },
                                            model: {
                                              value: _vm.editedItem.roles,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "roles",
                                                  $$v
                                                )
                                              },
                                              expression: "editedItem.roles",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: {
                                            xs12: "",
                                            sm12: "",
                                            md12: "",
                                          },
                                        },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              items: _vm.accessGroups,
                                              "item-text": "name",
                                              "item-value": "id",
                                              "menu-props": {
                                                maxHeight: "400",
                                              },
                                              label: "Monitoring Groups",
                                              multiple: "",
                                              disabled: "",
                                              hint: "Monitoring Groups can be edited from the AccessGroups view",
                                              "persistent-hint": "",
                                            },
                                            model: {
                                              value:
                                                _vm.editedItem.accessGroups,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "accessGroups",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "editedItem.accessGroups",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c(
                            "i",
                            [
                              _vm._v("Passwords can be updated using the "),
                              _c(
                                "v-icon",
                                {
                                  staticStyle: { "font-size": "18px" },
                                  attrs: { color: "grey lighten-1" },
                                },
                                [_vm._v("fas fa-lock-alt")]
                              ),
                              _vm._v(" icon in Users list"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mr-4",
                              attrs: {
                                color: "primary",
                                outlined: "",
                                rounded: "",
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.close.apply(null, arguments)
                                },
                              },
                            },
                            [_vm._v("Cancel")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "primary",
                                rounded: "",
                                disabled:
                                  !_vm.validUser ||
                                  (!(_vm.editedItem.id > 0) &&
                                    !_vm.editedItem.sendPwdEmail &&
                                    !_vm.editedItem.password),
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.save.apply(null, arguments)
                                },
                              },
                            },
                            [_vm._v("Save")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-dialog",
                {
                  attrs: { "max-width": "600px", persistent: "" },
                  model: {
                    value: _vm.pwdChangeDialog,
                    callback: function ($$v) {
                      _vm.pwdChangeDialog = $$v
                    },
                    expression: "pwdChangeDialog",
                  },
                },
                [
                  _c(
                    "v-card",
                    [
                      _c("v-card-title", [
                        _c("span", { staticClass: "headline" }, [
                          _vm._v("Update User Password"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-form",
                            {
                              ref: "pwdForm",
                              on: {
                                submit: function ($event) {
                                  $event.preventDefault()
                                },
                              },
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  autocomplete: "off",
                                  rules: [
                                    _vm.rules.required,
                                    _vm.rules.formatLogin,
                                  ],
                                  label: "Username",
                                },
                                model: {
                                  value: _vm.newLogin,
                                  callback: function ($$v) {
                                    _vm.newLogin = $$v
                                  },
                                  expression: "newLogin",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-checkbox", {
                                attrs: {
                                  label: "Email User to Setup Password*",
                                },
                                model: {
                                  value: _vm.sendPwdEmail,
                                  callback: function ($$v) {
                                    _vm.sendPwdEmail = $$v
                                  },
                                  expression: "sendPwdEmail",
                                },
                              }),
                              _vm._v(" "),
                              !_vm.sendPwdEmail
                                ? _c("PasswordEntry", {
                                    on: {
                                      "password-updated": _vm.updatePassword,
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mr-4",
                              attrs: {
                                color: "primary",
                                outlined: "",
                                rounded: "",
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.closePasswordDialog.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [_vm._v("Cancel")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "primary",
                                rounded: "",
                                disabled: !_vm.validPwd,
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.savePassword.apply(null, arguments)
                                },
                              },
                            },
                            [_vm._v("Save")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-data-table",
                {
                  staticClass: "elevation-1",
                  attrs: {
                    options: _vm.pagination,
                    headers: _vm.headers,
                    items: _vm.filteredUsers,
                    search: _vm.search,
                    loading: _vm.loading,
                  },
                  on: {
                    "update:options": function ($event) {
                      _vm.pagination = $event
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "item.id",
                      fn: function ({ item }) {
                        return [
                          _vm.isProfessional || _vm.isSU
                            ? _c("td", [_vm._v(_vm._s(item.id))])
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: "item.name",
                      fn: function ({ item }) {
                        return [
                          _c(
                            "td",
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: { to: "" },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.editItem(item)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(item.name))]
                              ),
                              _vm._v("\n               \n              "),
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on }) {
                                          return [
                                            item.collectionAgent
                                              ? _c(
                                                  "v-icon",
                                                  _vm._g(
                                                    { attrs: { small: "" } },
                                                    on
                                                  ),
                                                  [
                                                    _vm._v(
                                                      "fas fa-folder fa-fw"
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Collection Agent")]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "item.roles",
                      fn: function ({ item }) {
                        return [
                          _c("td", [
                            _vm._v(_vm._s(_vm.formatRoles(item.roles))),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "item.updatedDate",
                      fn: function ({ item }) {
                        return [
                          _c("td", [
                            _vm._v(
                              _vm._s(_vm.formatDateTime(item.updatedDate))
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "item.actions",
                      fn: function ({ item }) {
                        return [
                          _c(
                            "td",
                            { staticClass: "actions" },
                            [
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on }) {
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                {
                                                  staticStyle: {
                                                    height: "0px",
                                                    width: "0px",
                                                    "padding-right": "2px",
                                                  },
                                                  attrs: { text: "", icon: "" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.editItem(item)
                                                    },
                                                  },
                                                },
                                                on
                                              ),
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticStyle: {
                                                      "font-size": "18px",
                                                    },
                                                    attrs: {
                                                      color: "grey lighten-1",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "fas fa-pencil fa-fw"
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [_vm._v(" "), _c("span", [_vm._v("Edit")])]
                              ),
                              _vm._v(" "),
                              !item.isExternal
                                ? _c(
                                    "v-tooltip",
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on }) {
                                              return [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    {
                                                      staticStyle: {
                                                        height: "0px",
                                                        width: "0px",
                                                        "padding-right": "2px",
                                                      },
                                                      attrs: {
                                                        text: "",
                                                        icon: "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.changePassword(
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    on
                                                  ),
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticStyle: {
                                                          "font-size": "18px",
                                                        },
                                                        attrs: {
                                                          color:
                                                            "grey lighten-1",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "fas fa-lock-alt fa-fw"
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Change Password")]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on }) {
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                {
                                                  staticStyle: {
                                                    height: "0px",
                                                    width: "0px",
                                                  },
                                                  attrs: { text: "", icon: "" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.deleteUser(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                on
                                              ),
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticStyle: {
                                                      "font-size": "18px",
                                                    },
                                                    attrs: {
                                                      color: "grey lighten-1",
                                                    },
                                                  },
                                                  [_vm._v("fas fa-trash fa-fw")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [_vm._v(" "), _c("span", [_vm._v("Delete")])]
                              ),
                              _vm._v(" "),
                              _vm.canLaunchModule(item.login)
                                ? _c(
                                    "v-tooltip",
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on }) {
                                              return [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    {
                                                      staticStyle: {
                                                        height: "0px",
                                                        width: "0px",
                                                      },
                                                      attrs: {
                                                        text: "",
                                                        icon: "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.launchModule(
                                                            item,
                                                            "monitoring"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    on
                                                  ),
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticStyle: {
                                                          "font-size": "18px",
                                                        },
                                                        attrs: {
                                                          color:
                                                            "grey lighten-1",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "far fa-chart-line fa-fw"
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v("Launch CPM Monitoring"),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.canLaunchModule(item.login)
                                ? _c(
                                    "v-tooltip",
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on }) {
                                              return [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    {
                                                      staticStyle: {
                                                        height: "0px",
                                                        width: "0px",
                                                      },
                                                      attrs: {
                                                        text: "",
                                                        icon: "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.launchModule(
                                                            item,
                                                            "historical2"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    on
                                                  ),
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticStyle: {
                                                          "font-size": "18px",
                                                        },
                                                        attrs: {
                                                          color:
                                                            "grey lighten-1",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "far fa-chart-bar fa-fw"
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v("Launch CPM Analytics"),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.canLaunchModule(item.login)
                                ? _c(
                                    "v-tooltip",
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on }) {
                                              return [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    {
                                                      staticStyle: {
                                                        height: "0px",
                                                        width: "0px",
                                                      },
                                                      attrs: {
                                                        text: "",
                                                        icon: "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.launchModule(
                                                            item,
                                                            "rooms"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    on
                                                  ),
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticStyle: {
                                                          "font-size": "18px",
                                                        },
                                                        attrs: {
                                                          color:
                                                            "grey lighten-1",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "far fa-map-marked-alt fa-fw"
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v("Launch Workspace Insights"),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _vm._v(" "),
                  _vm._v(" "),
                  _vm._v(" "),
                  _vm._v(" "),
                  _vm._v(" "),
                  _c(
                    "v-alert",
                    {
                      attrs: {
                        slot: "no-results",
                        value: true,
                        color: "error",
                        type: "warning",
                      },
                      slot: "no-results",
                    },
                    [
                      _vm._v(
                        '\n              Your search for "' +
                          _vm._s(_vm.search) +
                          '" found no results.\n          '
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-card-actions", [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    on: {
                      click: function ($event) {
                        return _vm.newItem()
                      },
                    },
                  },
                  [_vm._v("New User")]
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }